<app-sidebar></app-sidebar>
<app-header></app-header>

<div class="content-wrapper">

    <div class="card text-center">
        <div class="col-md-12 no-print sticky">
            <div class="card">
                <div class="card-body justify-content-md-center">
                    <h2>การเบิกปัจจัย รายชาวไร่</h2>
                    <div id="loadingIndicator" style="display: none;">Loading...</div>
                    <table id="datatable" class="display" style="width:100%">

                    </table>
                </div>
            </div>
        </div>
    </div>
</div>